import { CKTag } from '@clearkit/react';
import {
  getColorClassNamesFromFitVariant,
  getDescriptionFromFitVariant,
  getFitVariantFromFitScore,
} from '../../../pages/IdealCustomerProfile/components/util';

type FitTagProps = {
  score?: number;
};

export function FitTag({ score }: FitTagProps) {
  const variant = getFitVariantFromFitScore(score);

  if (!variant) {
    return null;
  }

  return (
    <CKTag className={getColorClassNamesFromFitVariant(variant)}>
      {getDescriptionFromFitVariant(variant)}
    </CKTag>
  );
}
